// DS: IL9.2
import React from 'react';
export class JoinGroup extends React.PureComponent {
    render() {
        return /*#__PURE__*/ React.createElement("svg", {
            width: "88",
            height: "88",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ React.createElement("image", {
            href: "https://st.deviantart.net/eclipse/global/images/join-group.png?1",
            width: "100%",
            height: "100%"
        }));
    }
}
